import React from 'react'
import PropTypes from 'prop-types'
import { Flags } from 'react-feature-flags'
import IconCheck from '../../../img/icon-check.svg'
import IconQuestion from '../../../img/icon-question.svg'
import { objectFromEntries, pluralize } from '../../utils'
import { exemptionCategories } from '../../exemptions'
import ExemptionDetail from './ExemptionDetail'
import SVGWrapper from '../SVGWrapper'

class ItemDetail extends React.Component {
    constructor(props) {
        super(props)

        this.state = objectFromEntries(exemptionCategories.map(category => [category.category, true]))
    }

    render() {
        const { item } = this.props

        return (
            <div className="item-detail" id={item.id}>
                <div className="item-header">
                    {item.type === 'parcel' && (
                        <div className="image">
                            <>
                                <div className="spinner">
                                    <div className="bounce1" />
                                    <div className="bounce2" />
                                    <div className="bounce3" />
                                </div>
                                <img
                                    src={`/parcel-image/${item.county}/${item.id}`}
                                    loading="lazy"
                                    alt={`Outline of parcel at ${item.address.address}`}
                                />
                            </>
                        </div>
                    )}
                    {item.type === 'project' && (
                        <div className="image">
                            {item.children.length > 0 ? (
                                <>
                                    <img
                                        src={`/project-image/?parcels=${item.children.map(child => child.id).join()}`}
                                        alt={`Outline of ${item.label}`}
                                    />
                                    <div className="spinner">
                                        <div className="bounce1" />
                                        <div className="bounce2" />
                                        <div className="bounce3" />
                                    </div>
                                </>
                            ) : (
                                <div className="image-placeholder" />
                            )}
                        </div>
                    )}

                    {item.type === 'parcel' && (
                        <>
                            <div className="item-title">
                                APN <strong>{item.apn}</strong>
                            </div>
                        </>
                    )}
                    {item.type === 'project' && (
                        <>
                            <div className="item-title">
                                <strong>{item.label}</strong>
                            </div>
                            <div className="item-subtitle">
                                <div>
                                    {item.children.length} {pluralize(item.children.length, 'parcel', 's')}
                                </div>
                            </div>
                        </>
                    )}
                </div>
                <div className="status is-inline-desktop">
                    <span className="svg-icon icon-24">
                        <SVGWrapper title="A check mark icon">
                            <IconCheck />
                        </SVGWrapper>
                    </span>{' '}
                    {item.potential_count}
                </div>
                <div className="status is-inline-desktop" style={{ marginLeft: '30px' }}>
                    <span className="svg-icon icon-24 maybe">
                        <SVGWrapper title="A question mark icon">
                            <IconQuestion />
                        </SVGWrapper>
                    </span>{' '}
                    {item.possible_count}
                </div>
                <div className="item-info">
                    {item.type === 'parcel' && (
                        <div className="parcel-info-box">
                            <table>
                                <tbody>
                                    {item.address.city && (
                                        <tr>
                                            <td>City:</td>
                                            <td>{item.address.city}</td>
                                        </tr>
                                    )}
                                    {item.county && (
                                        <tr>
                                            <td>County:</td>
                                            <td>{item.county}</td>
                                        </tr>
                                    )}
                                    {item.mpo && (
                                        <tr>
                                            <td>MPO:</td>
                                            <td>{item.mpo}</td>
                                        </tr>
                                    )}
                                    {item.specific_plan && (
                                        <tr>
                                            <td>Specific Plan:</td>
                                            <td>{item.specific_plan}</td>
                                        </tr>
                                    )}
                                    {item.address && (
                                        <tr>
                                            <td>Address:</td>
                                            <td>
                                                {item.address.address || 'undefined'}
                                                <br />
                                                {item.address.city || 'undefined'}, {item.address.state || 'undefined'}{' '}
                                                {item.address.zip || 'undefined'}
                                            </td>
                                        </tr>
                                    )}
                                    {item.census_block && (
                                        <tr>
                                            <td>Census Block:</td>
                                            <td>{item.census_block.split(' ').pop()}</td>
                                        </tr>
                                    )}
                                    {item.zoning_designation && (
                                        <tr>
                                            <td>Zoning Designation:</td>
                                            <td>{Object.keys(item.zoning_designation).join(', ')}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {item.type === 'project' && (
                        <div className="parcel-info-boxes">
                            {item.children.map(parcel => (
                                <div className="parcel-info-box" key={parcel.id}>
                                    <table>
                                        <tbody>
                                            {parcel.apn && (
                                                <tr>
                                                    <td>APN:</td>
                                                    <td>{parcel.apn}</td>
                                                </tr>
                                            )}
                                            {parcel.address.city && (
                                                <tr>
                                                    <td>City:</td>
                                                    <td>{parcel.address.city}</td>
                                                </tr>
                                            )}
                                            {parcel.county && (
                                                <tr>
                                                    <td>County:</td>
                                                    <td>{parcel.county}</td>
                                                </tr>
                                            )}
                                            {parcel.mpo && (
                                                <tr>
                                                    <td>MPO:</td>
                                                    <td>{parcel.mpo}</td>
                                                </tr>
                                            )}
                                            {parcel.specific_plan && (
                                                <tr>
                                                    <td>Specific Plan:</td>
                                                    <td>{parcel.specific_plan}</td>
                                                </tr>
                                            )}
                                            {parcel.address && (
                                                <tr>
                                                    <td>Address:</td>
                                                    <td>
                                                        {parcel.address.address || 'undefined'}
                                                        <br />
                                                        {parcel.address.city || 'undefined'},{' '}
                                                        {parcel.address.state || 'undefined'}{' '}
                                                        {parcel.address.zip || 'undefined'}
                                                    </td>
                                                </tr>
                                            )}
                                            {parcel.census_block && (
                                                <tr>
                                                    <td>Census Block:</td>
                                                    <td>{parcel.census_block.split(' ').pop()}</td>
                                                </tr>
                                            )}
                                            {parcel.zoning_designation && (
                                                <tr>
                                                    <td>Zoning Designation:</td>
                                                    <td>{Object.keys(parcel.zoning_designation).join(', ')}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            ))}
                        </div>
                    )}

                    {item.exemptions.map(category => {
                        const showDescription = this.state[category.category]

                        return (
                            <React.Fragment key={category.category}>
                                <h5 className="title is-5">
                                    {category.label}{' '}
                                    <button
                                        className="expand-link"
                                        onClick={() => this.setState({ [category.category]: !showDescription })}
                                        onKeyDown={e =>
                                            e.key === 'Enter'
                                                ? this.setState({ [category.category]: !showDescription })
                                                : null
                                        }
                                    >
                                        {this.state[category.category] ? 'hide' : 'show description'}
                                    </button>
                                </h5>
                                <div className="description">{showDescription && category.description}</div>

                                {category.exemptions.map(exemption => (
                                    <ExemptionDetail exemption={exemption} key={exemption.code} />
                                ))}
                            </React.Fragment>
                        )
                    })}
                </div>
            </div>
        )
    }
}

ItemDetail.propTypes = {
    item: PropTypes.shape({}).isRequired
}

export default ItemDetail
